import { render, staticRenderFns } from "./InputBase.vue?vue&type=template&id=64763b5a&scoped=true"
import script from "./InputBase.vue?vue&type=script&lang=ts"
export * from "./InputBase.vue?vue&type=script&lang=ts"
import style0 from "./InputBase.vue?vue&type=style&index=0&id=64763b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64763b5a",
  null
  
)

export default component.exports